<template>
  <div id="index">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="search_tab">
      <div class="search_Text w1200">
        和 "{{keyword}}" 相关的内容
      </div>
      <div class="search_tab_c w1200">
        <router-link :to="{path:'/search',query:{keyword:keyword}}"><span :class="{'side': num == 0}">全部</span>
        </router-link>
        <router-link :to="{path:'/search_course',query:{keyword:keyword}}"><span :class="{'side': num == 1}">课程</span>
        </router-link>
        <router-link :to="{path:'/search_TestPaper',query:{keyword:keyword}}"><span :class="{'side': num == 2}">练习-套卷</span>
        </router-link>
        <router-link :to="{path:'/search_Section',query:{keyword:keyword}}"><span :class="{'side': num == 3}">练习-单项</span>
        </router-link>
        <!-- <router-link :to="{path:'/search_languageTest',query:{keyword:keyword}}"><span
            :class="{'side': num == 4}">全真模考</span></router-link> -->
      </div>
    </div>
    <div class="main w1200">
      <div class="search_null" v-if="courseArrNum==0">
        <img src="../../assets/courselist/search.png" alt="" class="wuImg">
        <p>没有你要找的内容，可以换个关键词试试</p>
      </div>
      <div class="search_main class_main" v-else>
        <!-- <div class="search_con">课程找到{{courseArrNum}}条结果
        </div> -->
        <ul class="clearfix">
          <li v-for="item,index in courseArr">
            <router-link :to="{path:'/course_details',query:{Id:item.Id,nav:8}}">
              <dl>
                <dt><img :src="item.CoverImg"><i
                    :class="[item.Type == 2?'courseBox':'']">{{item.Type == 2?'课程包':''}}</i></dt>
                <dd class="dd1">
                  <h2>{{item.Title}}</h2>
                  <p class="p1" v-if="item.Label">
                    <span>{{item.Field1}}</span>
                  </p>
                  <div class="p3">
                    ￥{{item.Price}}
                  </div>
                </dd>
                <!-- <dd class="dd2">
                  <p class="p2">
                    {{item.Label.replace(/,/g, "·")}}{{"·"+item.Field2+'课时'}}
                  </p>
                  <h2>{{item.Title}}</h2>
                  <p class="p2">
                    {{item.Field4}}
                  </p>
                  <p class="p1" v-if="item.Field1">
                    <span>{{ item.Field1 }}</span>
                    <span>{{ item.Field3 }}</span>
                  </p>
                  <p class="p4">
                    立即学习
                  </p>
                </dd> -->
              </dl>
            </router-link>
          </li>
        </ul>
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="12" :total="total" background
            layout="total,prev, pager, next, jumper,->">
          </el-pagination>
        </div>
        <!-- block end -->
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import Header from '../../components/header/Header.vue'; //公共头部
  export default {
    components: {
      // 将组件隐射为标签,登陆弹窗
      Header,
    },
    metaInfo() {
      return {
        title: '启德考培在线',
        meta: [{
            name: "keywords",
            content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程"
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
          },
        ],
      };
    },
    data() {
      return {
        pageTypeId: 13, //首页banner图
        num: 1,
        listBox: [], //列表盒子
        limit: 12,
        currentPage: 1,
        courseType: 0,
        keyword: '',
        courseArr: [],
        courseArrNum: 0,
        total: 0, //总条数
      }
    },
    created() { //自动触发写入的函数
      let that = this
      that.keyword = that.$route.query.keyword
      // 课程
      that.getSearch(that.currentPage, 48, that.limit, that.keyword)
    },
    methods: {
      iconShrink() {
        this.screenup = true
      },
      iconOpen() {
        this.screenup = false
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        let that = this;
        // console.log(`当前页: ${val}`);
        that.currentPage = val
        that.getSearch(that.currentPage, 48, that.limit, that.keyword)
      },
      getSearch(currentPage, courseType, limit, keyword) {
        // console.log("keyword", currentPage, courseType, limit, keyword)
        let that = this;
        this.$api.get('https://schoolapi.eiceducation.com.cn/api/Search?page=' + currentPage + '&limit=' + limit +
          '&ContentType=' + courseType + '&keyword=' + keyword, '',
          (res) => {
            // console.log(res, 'res')
            if (res.data.code == 200) {
              if (courseType == 48) {
                that.total = res.data.count;
                that.courseArrNum = res.data.count;
                that.courseArr = res.data.results
              }
              // console.log(that.courseArr, "courseArr")
            }
          })

      },
    },
  }
</script>

<style scoped>
  .search_tab {
    padding: 30px;
  }

  .search_tab .search_Text {
    height: 20px;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    text-align: left;
    margin-bottom: 50px;
    position: relative;
  }

  .search_tab .search_Text a {
    width: 123px;
    height: 25px;
    position: absolute;
    top: 13px;
    right: 0;
    background: url(../../assets/index/more.png) no-repeat;
    background-size: cover;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    text-align: center;
  }

  .search_tab_c span {
    display: inline-block;
    font-weight: 400;
    font-size: 26px;
    color: #333333;
    line-height: 26px;
    margin-right: 50px;
    cursor: pointer;
    font-weight: 400;
    transition: all .25s ease-in;
    -moz-transition: all .25s ease-in;
    -webkit-transition: all .25s ease-in;
  }

  .search_tab_c span:hover {
    font-weight: 500;
    color: #FF0659;
  }


  .search_tab_c span.side {
    font-weight: 500;
    color: #FF0659;
  }

  .main {
    padding-top: 20px;
    padding-bottom: 78px;
  }

  .search_con {
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    margin-bottom: 30px;
  }

  .search_main {
    margin-bottom: 50px;
  }

  .class_main ul li {
    width: 285px;
    height: 295px;
    float: left;
    background: #FBFBFB;
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    overflow: hidden;
  }

  .class_main ul li:nth-child(4n) {
    margin-right: 0;
  }

  .class_main li dt {
    width: 285px;
    height: 185px;
    overflow: hidden;
  }

  .class_main li dt img {
    width: 285px;
    height: 185px;
    display: block;
  }

  .class_main li .dd1 {
    width: 265px;
    padding: 10px 10px 0;
    text-align: left;
    background: url(../../assets/index/to1.png) 261px 10px no-repeat;
    background-size: 14px 14px;
  }

  .class_main li .dd1 h2 {
    height: 20px;
    font-size: 20px;
    color: #000000;
    line-height: 20px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
  }

  .class_main li .dd1 .p1 {
    width: 100%;
    height: 22px;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .class_main li .dd1 .p1 span {
    display: inline-block;
    padding: 0 10px;
    height: 22px;
    background: rgba(135, 141, 255, 0.05);
    border-radius: 13px 13px 13px 13px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    color: #878DFF;
    margin-right: 10rpx;
  }

  .class_main li .dd1 .p3 {
    height: 26px;
    font-weight: 400;
    font-size: 26px;
    color: #FF0659;
    line-height: 26px;
    text-align: right;
  }

  .class_main li .dd2 {
    width: 265px;
    max-height: 200px;
    padding: 18px 10px 0;
    text-align: left;
    position: absolute;
    bottom: -300px;
    left: 0;
    background: #FBFBFB;
    transition: 0.5s ease all;
  }

  .class_main li:hover .dd2 {
    bottom: 0;
  }

  .class_main li .dd2 h2 {
    height: 20px;
    font-size: 20px;
    color: #000000;
    line-height: 20px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
  }

  .class_main li .dd2 .p2 {
    font-weight: 350;
    font-size: 12px;
    color: #666666;
    line-height: 18px;
    margin-bottom: 8px;
  }

  .class_main li .dd2 .p1 {
    width: 100%;
    margin-bottom: 10px;
  }

  .class_main li .dd2 .p1 span {
    display: inline-block;
    padding: 0 10px;
    height: 22px;
    background: rgba(135, 141, 255, 0.05);
    border-radius: 13px 13px 13px 13px;
    line-height: 22px;
    background: rgba(135, 141, 255, 0.05);
    text-align: center;
    font-size: 12px;
    color: #878DFF;
    margin-right: 10px;
    margin-bottom: 4px;
  }

  .class_main li .dd2 .p4 {
    font-weight: 400;
    font-size: 12px;
    color: #337CFF;
    line-height: 12px;
    text-align: right;
    padding-right: 24px;
    margin-bottom: 20px;
    background: url(../../assets/index/to2.png) right no-repeat;
    background-size: 14px 14px;
  }

  .block {
    width: 1180px;
    margin: 0 auto;
    text-align: right;
  }

  .search_null {
    width: 1180px;
    margin: 0 auto;
    text-align: center;
  }

  .search_null p {
    font-size: 12px;
    color: #333;
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/page2/search/search_course.vue